// @ts-nocheck
import { EMPTY_OBJECT } from '../../../../const/CommonConst';
import {
  useMutationEngine,
  useNewQueryEngine,
} from '../../../../queries/useDataEngine';
import { ThemeAppearanceService } from './themeAppearanceService';

const THEME_APPEARANCE = 'themeAppearance';

export const THEME_APPEARANCE_QUERY_KEYS = {
  ALL: [THEME_APPEARANCE],
  theme: {
    ROOT: [THEME_APPEARANCE, 'theme'],
    key: (params = EMPTY_OBJECT) => [THEME_APPEARANCE, 'theme', params],
  },
};

export const useThemeAppearanceQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useNewQueryEngine(
    THEME_APPEARANCE_QUERY_KEYS.theme.key,
    ThemeAppearanceService.getTheme,
    params,
    options
  );
};

export const useUpdateThemeMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(ThemeAppearanceService.updateTheme, {
    ...options,
    invalidateQueries: [THEME_APPEARANCE_QUERY_KEYS.theme.ROOT],
  });
};

export const useSaveUserThemeTypeMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(ThemeAppearanceService.saveUserThemeType, {
    ...options,
    invalidateQueries: [THEME_APPEARANCE_QUERY_KEYS.theme.ROOT],
  });
};
